/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useMemo } from "react";
import get from "lodash/get";
import { StoryElement, WithLazy } from "@quintype/components";

import Tags from "../story-elements/tags";
import AlsoRead from "../story-elements/also-read";
import Slideshow from "../story-elements/slide-show";
import Attachment from "../story-elements/attachment";
import FactCheckView from "../story-elements/fact-check";
import ImageGallery from "../story-elements/image-gallery";
import MovieReviewView from "../story-elements/movie-review";
import GadgetReviewView from "../story-elements/gadget-review";
import ReferenceElement from "../story-elements/reference-element";
import BookReviewView from "../story-elements/book-review";
import SubscribeCard from "../../molecules/subscribe-card";
import PublishedAt from "./published-at";
import { getHeroOverrideElement } from "../../helper/utils";

// import SectionStories from "./section-stories";

import { AdContainer } from "../../ads";
import TaboolaAd from "../../ads/taboola-ad";

import BlockQuoteIcon from "../../atoms/icons/blockquote-icon";
import QuoteIcon from "../../atoms/icons/quote-icon";
import PromotionalMessage from "./promotional-message";
import ImagewithCaption from "../../molecules/Image-caption";
import ImagewithCaptionWithoutShare from "../../molecules/image-without-share";

import { getPrimaryEmbed } from "../story-header/embed-element";

import "./story-elements.m.css";
import QandA from "./q-and-a";
import useAdType from "../../helper/useAdType";
import ElectionBrickWall from "../../molecules/election-brick-wall";
import {
  assemblyElection2024ConstituencyData,
  assemblyElection2024SlugData_Delhi,
  assemblyElection2025SlugData_Bihar,
  assemblyElection2024SlugData,
  assemblyElection2024SlugData_JK_HR
} from "../../molecules/election-brick-wall-with-search/election-data-2024";
import { useSelector } from "react-redux";
import { throttle } from "lodash";
import DownArrow from "../../atoms/other-icons/DownArrow";
// import CustomWidget from "../../atoms/custom-widget";
import NewBodyWidget from "../../atoms/new-body-banner";
// import PaywallCard from "../../molecules/paywall";

let countPara = 0;
let hasRenderedMidAd1 = false;
let hasRenderedMidAd2 = false;

const getParagraphsFromHtml = (html) => {
  if (!html) return [];
  const regex = /<([a-zA-Z0-9]+)\b[^>]*>([\s\S]*?)<\/\1>/g;
  const paragraphs = [];
  let match;
  while ((match = regex.exec(html)) !== null) {
    paragraphs.push(match[0]);
  }
  if (paragraphs.length === 0 && html.trim()) {
    paragraphs.push(html);
  }
  return paragraphs;
};

const countWordsInHtml = (html) => {
  if (!html) return 0;
  const cleanText = html.replace(/<[^>]*>/g, " ").trim();
  if (!cleanText) return 0;
  return cleanText.split(/\s+/).filter(Boolean).length;
};

const getParagraphsArr = (html) => {
  // const pTagRegex = /<p\b[^>]*>([\s\S]*?)<\/p>/g;
  // const matches = html.match(pTagRegex);
  // return matches;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const elements = [...doc.body.children];
  return elements.map((el) => el.outerHTML);
};

const CustomStoryElement = ({ element, elementIndex, adType, story, tempHideAd }) => {
  const rawHtml = element && element.text;
  const [paragraphs, setParagraphs] = useState([]);
  const storyTemplate = story && story["story-template"];
  const blockedTemplates = ["listicle", "live-blog"];

  useEffect(() => {
    let isWebView = false;
    if (typeof window !== "undefined") {
      const searchparam = window.location.search;
      if (searchparam.includes("app=true")) {
        isWebView = true;
      }
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = rawHtml;
      const paragraphElements = getParagraphsArr(rawHtml);
      const parsedParagraphs =
        paragraphElements &&
        paragraphElements.map((p, index) => {
          const tempElement = document.createElement("div");
          tempElement.innerHTML = p;
          // Check if the element contains a <p> tag
          const hasPTag = tempElement.getElementsByTagName("p").length > 0;
          if (hasPTag) {
            countPara = countPara + 1;
          }
          // Paywall paragraph injection disabled.
          if (countPara > 0 && countPara === 4 && !hasRenderedMidAd2) {
            hasRenderedMidAd2 = true;
            return (
              <div key={index}>
                <div className="story-element story-element-text" dangerouslySetInnerHTML={{ __html: p }}></div>
                {!isWebView && (story["story-template"] === "text" || story["story-template"] === "syndicated" || story["story-template"] === "dh-exclusive") && (
                  <div id="SecondAdContainer">
                    <div styleName="ad-wrapper" className="hide-desktop">
                      <AdContainer
                        storyPageAds={true}
                        AdClassName="standard-336x280"
                        id="div-gpt-ad-1726651118047-0"
                        desktop={false}
                        mobile="DH_MWeb_AT_Mid02"
                      />
                      {window && window.innerWidth < 767 && <div
                        id="taboola-mid-article-personalisation"
                        styleName="taboola-4u"
                        ref={(el) => {
                          if (!el) return;

                          window._taboola = window._taboola || [];
                          window._taboola.push({
                            mode: "organic-thumbnails-mid-personalisation-mob",
                            container: "taboola-mid-article-personalisation",
                            placement: "Mid Article Personalisation",
                            target_type: "mix",
                          });
                          window._taboola.push({ flush: true });
                        }}
                      />}
                    </div>
                    <div styleName="ad-wrapper" className="hide-mobile">
                      <AdContainer
                        AdClassName="standard-970x90"
                        id="div-gpt-ad-1752820478684-0"
                        desktop="DH_Desktop_AT_LB_Mid"
                        mobile={false}
                      />
                      {window && window.innerWidth >= 767 && <div
                        id="taboola-mid-article-personalisation"
                        ref={(el) => {
                          if (!el) return;

                          window._taboola = window._taboola || [];
                          window._taboola.push({
                            mode: "organic-thumbnails-mid-personalisation-desk",
                            container: "taboola-mid-article-personalisation",
                            placement: "Mid Article Personalisation",
                            target_type: "mix",
                          });
                          window._taboola.push({ flush: true });
                        }}
                      />}
                    </div>
                  </div>
                )}
                {/* PaywallCard render disabled */}
              </div>
            );
          }

          if (
            !blockedTemplates.includes(storyTemplate) &&
            countPara > 0 &&
            countPara === 1 &&
            !hasRenderedMidAd1 &&
            !["listicle", "photo", "news-briefs"].includes(story["story-template"]) &&
            !tempHideAd
          ) {
            hasRenderedMidAd1 = true;

            return (
              <div key={index}>
                <div className="story-element story-element-text" dangerouslySetInnerHTML={{ __html: p }}></div>
                {/* <CustomWidget /> */}
                <NewBodyWidget />
                <div id={storyTemplate !== "podcast" && "FirstAdContainer"}>
                  {storyTemplate !== "podcast" && (
                    <div styleName="ad-wrapper" className="hide-desktop">
                      <AdContainer
                        storyPageAds={true}
                        AdClassName="standard-336x280"
                        id={adType === "izooto" ? "div-gpt-ad-1711972030627-0" : "div-gpt-ad-1680157855094-0"}
                        mobile={adType === "izooto" ? "DH_MWeb_AT_Mid_ym" : "DH_MWeb_AT_Mid"}
                        isExternalAdPath={adType === "izooto" ? true : false}
                      />
                    </div>
                  )}
                  <div styleName="ad-wrapper" className="hide-mobile">
                    <AdContainer
                      AdClassName="standard-336x280"
                      id={adType === "izooto" ? "div-gpt-ad-1711971649563-0" : "div-gpt-ad-1680156704803-0"}
                      desktop={adType === "izooto" ? "DH_Desktop_AT_Mid_ym" : "DH_Desktop_AT_Mid"}
                      isExternalAdPath={adType === "izooto" ? true : false}
                    />
                  </div>
                </div>
                {/* PaywallCard render disabled */}
              </div>
            );
          }

          return (
            <div key={index}>
              <div className="story-element story-element-text" dangerouslySetInnerHTML={{ __html: p }}></div>
              {/* PaywallCard render disabled */}
            </div>
          );
        });
      setParagraphs(parsedParagraphs);
    }
  }, []);

  return <div>{paragraphs}</div>;
};
const fourthTextStoryElementID = (story) => {
  const textStoryElements = [];
  story.cards.map((element) =>
    element["story-elements"]?.map((element) => {
      if (element.subtype === null && element.type === "text") {
        textStoryElements.push(element);
      }
    })
  );
  return textStoryElements.length > 5 ? textStoryElements[3].id : null;
};

const getElements = (element, story, elementIndex, cardIndex, isImmersiveStory, adType, tempHideAd) => {
  if (!isImmersiveStory) {
    const primaryEmbed = getPrimaryEmbed(story);
    const primaryEmbedId = primaryEmbed?.id ? primaryEmbed.id : null;
    if (
      element.id === primaryEmbedId &&
      (story["story-template"] == "embed" ||
        story["story-template"] == "video-playlist" ||
        story["story-template"] == "podcast")
    ) {
      return null;
    }
  }
  const elementType = element.type;

  if (element.metadata?.["promotional-message"] === true) {
    return null;
  }

  if (element && element.type === "text" && element.subtype === null) {
    return (
      <div id="text-element-with-ad">
        <CustomStoryElement
          element={element}
          elementIndex={elementIndex}
          adType={adType}
          story={story}
          tempHideAd={tempHideAd}
        />
      </div>
    );
  }

  switch (element.subtype) {
    case "attachment": {
      return <Attachment element={element} />;
    }
    case "references": {
      const referenceObj = get(element, ["story-elements"], []);
      return referenceObj.map((element, index) => <ReferenceElement element={element} key={index} />);
    }
    case "image-gallery": {
      if (element.metadata.type === "gallery") {
        return <WithLazy margin="50px">{() => <ImageGallery element={element} story={story} />}</WithLazy>;
      }

      if (element.metadata.type === "slideshow") {
        return <WithLazy margin="50px">{() => <Slideshow story={story} element={element} />}</WithLazy>;
      }
      break;
    }
    case "blockquote": {
      return (
        <div styleName="blockquote-wrapper">
          <BlockQuoteIcon width="40" height="40px" />
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "also-read": {
      return <AlsoRead element={element} story={story} isImmersiveStory={isImmersiveStory} />;
    }
    case "quote": {
      return (
        <div styleName="quote-contents" className="exclusive-contents">
          <QuoteIcon />
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "q-and-a": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "question": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "answer": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "table": {
      if (element.metadata["has-header"] == true) {
        const updateEle = { ...element };
        updateEle.metadata["has-header"] = false;
        return (
          <div className="has-head story-element story-element-data">
            <StoryElement element={updateEle} key={updateEle.id} story={story} />;
          </div>
        );
      } else {
        return <StoryElement element={element} key={element.id} story={story} />;
      }
    }
    default:
      if (elementType === "image") {
        if (
          story["story-template"] === "photo" ||
          story["story-template"] === "text-new" ||
          story["story-template"] === "sponsored" ||
          story["story-template"] === "brandspot-client-story"
        ) {
          return (
            <div styleName="share-wrapper">
              <StoryElement
                renderTemplates={{ image: ImagewithCaption }}
                element={element}
                key={element.id}
                story={story}
                index={elementIndex}
              />
            </div>
          );
        } else {
          return (
            <StoryElement
              renderTemplates={{ image: ImagewithCaptionWithoutShare }}
              element={element}
              key={element.id}
              story={story}
            />
          );
        }
      } else {
        return (
          <div styleName="share-wrapper">
            {story["story-template"] !== "podcast" || story["story-template"] !== "video-playlist" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : elementType !== "jsembed" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : element.subtype === "" || element.subtype === null ? (
              console.log("element.subtype ignored:>:>:>:>:>", elementType, element.subtype)
            ) : (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            )}
          </div>
        );
      }
  }
};

export const StoryCard = ({
  story,
  card,
  cardIndex,
  index,
  isNewTextStory,
  showAlsoReadOnTop = true,
  adType,
  isMobile,
  isImmersiveStory,
  tempHideAd
}) => {
  const elements = card["story-elements"];
  const heroImageOverride = story?.["metadata"]?.["story-attributes"]?.["heroimageoverride"]?.[0] === "true";
  const deleteOverrideElement = story?.["metadata"]?.["story-attributes"]?.["deleteoverrideelement"]?.[0] === "true";
  const { component: RenderHeroComponent, elementId: heroElementId } =
    getHeroOverrideElement({
      story,
      heroImageOverride,
    });

  const wrappedAllElementCard = (elements, story, card, cardIndex, adType, isMobile) => {
    let allAlsoReads = [];
    let allWrappedElements = [];

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      if (element.id === heroElementId && heroImageOverride && deleteOverrideElement) {
        continue;
      }

      if (element.subtype === "also-read") {
        allAlsoReads.push(element);
      } else {
        if (allAlsoReads.length > 1) {
          allWrappedElements.push(
            <div styleName="also-read-main-wrapper">
              {allAlsoReads.map((element, elementIndex) => (
                <AlsoRead
                  story={story}
                  element={element}
                  isConsecutive={true}
                  elementIndex={elementIndex}
                  isImmersiveStory={isImmersiveStory}
                />
              ))}
            </div>
          );
        } else {
          allWrappedElements.push(
            ...allAlsoReads.map((element, elementIndex) => (
              <AlsoRead
                story={story}
                element={element}
                isConsecutive={false}
                elementIndex={elementIndex}
                isImmersiveStory={isImmersiveStory}
              />
            ))
          );
        }

        allAlsoReads = [];
        allWrappedElements.push(getElements(element, story, i, cardIndex, isImmersiveStory, adType, tempHideAd));
      }
    }
    if (allAlsoReads.length > 1) {
      allWrappedElements.push(
        <div styleName="also-read-main-wrapper">
          {allAlsoReads.map((element, elementIndex) => (
            <AlsoRead
              story={story}
              element={element}
              isConsecutive={true}
              elementIndex={elementIndex}
              isImmersiveStory={isImmersiveStory}
            />
          ))}
        </div>
      );
    } else {
      allWrappedElements.push(
        ...allAlsoReads.map((element, elementIndex) => (
          <AlsoRead
            story={story}
            element={element}
            isConsecutive={false}
            elementIndex={elementIndex}
            isImmersiveStory={isImmersiveStory}
          />
        ))
      );
    }
    return allWrappedElements;
  };
  return (
    <div
      styleName={`story-card ${isNewTextStory ? "card-border" : ""}`}
      key={card.id}
      id={card.id}
      className="story-card"
    >
      {wrappedAllElementCard(elements, story, card, cardIndex, adType, isMobile).map((element, elementIndex) => {
        const elementType = element?.props?.children?.props?.element?.type;
        return (
          <React.Fragment key={elementIndex}>
            <React.Fragment>{element}</React.Fragment>
            {/* {fourthTextStoryElementID(story) === element?.id &&
            (story["story-template"] === "text" || story["story-template"] === "syndicated") &&
            story["story-template"] !== "immersive" ? (
              <SectionStories story={story} />
            ) : null} */}
            {cardIndex === 0 &&
              elementIndex === 0 &&
              elementType !== "text" && elementType !== "jsembed" &&
              !["listicle", "photo", "news-briefs", "immersive"].includes(story["story-template"]) &&
              !tempHideAd ? (
              <>
                <div styleName="ad-wrapper" key={index}>
                  {isMobile ? (
                    <AdContainer
                      AdClassName="standard-336x280"
                      id={adType === "izooto" ? "div-gpt-ad-1711972030627-0" : "div-gpt-ad-1680156704803-0"}
                      mobile={adType === "izooto" ? "DH_MWeb_AT_Mid_ym" : "DH_MWeb_AT_Mid"}
                      isExternalAdPath={adType === "izooto" ? true : false}
                    />
                  ) : (
                    <AdContainer
                      AdClassName="standard-336x280"
                      id={adType === "izooto" ? "div-gpt-ad-1711971649563-0" : "div-gpt-ad-1680156704803-0"}
                      desktop={adType === "izooto" ? "DH_Desktop_AT_Mid_ym" : "DH_Desktop_AT_Mid"}
                      isExternalAdPath={adType === "izooto" ? true : false}
                    />
                  )}
                </div>
              </>
            ) : null}
          </React.Fragment>
        );
      })}
    </div>
  );
};

const getArticlesRemaining = () => {
  const count = sessionStorage.getItem("articles_remaining");
  if (count === null || count === undefined) return null;
  const parsed = parseInt(count, 10);
  return isNaN(parsed) ? null : parsed;
};

const getUpdatedCards = (cards) => {
  const updatedCards = [];
  let alsoReadElements = [];

  for (let card = 0; card < cards.length; card++) {
    const firstCard = cards[card];
    const secondCard = cards[card + 1];
    const firstCardLastElement = firstCard["story-elements"][firstCard["story-elements"].length - 1];
    const lastCard = cards[cards.length - 1];

    if (firstCardLastElement?.subtype === "also-read" && secondCard) {
      for (let element = 0; element < secondCard["story-elements"].length; element++) {
        if (secondCard["story-elements"][element]?.subtype === "also-read") {
          alsoReadElements.push(secondCard["story-elements"][element]);
        } else {
          break;
        }
      }
      firstCard["story-elements"] = [...firstCard["story-elements"], ...alsoReadElements];
      updatedCards.push(firstCard);
      const updatedsecondCardElements = secondCard["story-elements"].filter(
        (element) => !alsoReadElements.includes(element)
      );
      secondCard["story-elements"] = updatedsecondCardElements;
      if (secondCard.id === lastCard.id) {
        updatedCards.push(secondCard);
      }
    } else {
      if (!updatedCards.includes(firstCard)) {
        updatedCards.push(firstCard);
      }
    }
    alsoReadElements = [];
  }

  return updatedCards;
};

const StoryElements = ({
  story,
  index,
  cards,
  isFactCheck,
  isMovieReview,
  isGadgetReview,
  isBookReview,
  isSponsoredStory,
  isBrandspotClientStory,
  isImmersiveStory,
  isNewTextStory,
  fontSize
}) => {
  const template = story["story-template"] ?? "text";
  const isBrandspotNoAdStory = template === "brandspot-with-no-ad";

  const [isMobile, setIsMobile] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowReadMore, setShouldShowReadMore] = useState(false);
  const [storyContentMaxHeight, setStoryContentMaxHeight] = useState(null);
  const [renderTaboolaAd, setRenderTaboolaAd] = useState(false);
  const [clipHeight, setClipHeight] = useState(null);
  const sponsoredText = story?.["metadata"]?.["story-attributes"]?.["sponsorednote"]?.[0] === "true" && isSponsoredStory;
  const storyContentRef = useRef(null);
  const contentRef = useRef(null);
  const mainRef = useRef(null);
  const resizeDebounceRef = useRef(null);
  // Premium story/paywall logic is disabled in this file.
  // const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
  // const tags = story.tags || [];
  // const isPremiumStory = tags.some(tag => tag.name === "premium" || tag.name === "Premium");


  const adType = useAdType();
  const showBrickWall = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "show_brickWall"], false)
  );

  const tempHideAd =
    template === "brandspot-with-no-ad" ||
    story?.slug?.includes("dhbrandspot-pr/best-crypto-casinos-2025-my-go-to-sites-for-bitcoin-gambling-3470705");

  useEffect(() => {
    if (mainRef.current && isImmersiveStory && fontSize) {
      mainRef.current.style.setProperty("--storyContentFont", `${fontSize}px`);
      mainRef.current.style.setProperty("--base", `${fontSize}px`);
    }
  }, [isImmersiveStory, fontSize]);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);

  const midAdsConfig = {
    2: {
      mobile: { id: "div-gpt-ad-1680157855094-0", slot: "DH_MWeb_AT_Mid", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1680156704803-0", slot: "DH_Desktop_AT_Mid" }
    },
    4: {
      mobile: { id: "div-gpt-ad-1726651118047-0", slot: "DH_MWeb_AT_Mid02", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1754393834239-0", slot: "DH_Desktop_AT_Mid02" }
    },
    6: {
      mobile: { id: "div-gpt-ad-1754032830774-0", slot: "DH_MWeb_AT_Mid03", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1754393928790-0", slot: "DH_Desktop_AT_Mid03" }
    },
    8: {
      mobile: { id: "div-gpt-ad-1754033273317-0", slot: "DH_MWeb_AT_Mid04", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1754393963082-0", slot: "DH_Desktop_AT_Mid04" }
    },
    10: {
      mobile: { id: "div-gpt-ad-1754033353593-0", slot: "DH_MWeb_AT_Mid05", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1754394058619-0", slot: "DH_Desktop_AT_Mid05" }
    }
  };

  const updateCards = getUpdatedCards(cards);

  // const paywallPosition = useMemo(() => {
  //   if (!isPremiumStory || isAdfree) return null;

  //   let totalWords = 0;
  //   let found = false;
  //   let targetElementId = null;
  //   let targetParagraphIndex = -1;

  //   for (let card of updateCards) {
  //     const elements = card["story-elements"] || [];
  //     for (let element of elements) {
  //       if (element.type === "text" && element.subtype === null) {
  //         const rawHtml = element.text || "";
  //         const paragraphs = getParagraphsFromHtml(rawHtml);

  //         for (let pIdx = 0; pIdx < paragraphs.length; pIdx++) {
  //           const p = paragraphs[pIdx];
  //           const wordCount = countWordsInHtml(p);
  //           totalWords += wordCount;

  //           if (totalWords >= 150 && !found) {
  //             targetElementId = element.id;
  //             targetParagraphIndex = pIdx;
  //             found = true;
  //             break;
  //           }
  //         }
  //       }
  //       if (found) break;
  //     }
  //     if (found) break;
  //   }

  //   if (found) {
  //     return {
  //       elementId: targetElementId,
  //       paragraphIndex: targetParagraphIndex,
  //       isLast: false
  //     };
  //   } else {
  //     let lastElementId = null;
  //     let lastParagraphIndex = -1;
  //     for (let i = updateCards.length - 1; i >= 0; i--) {
  //       const elements = updateCards[i]["story-elements"] || [];
  //       for (let j = elements.length - 1; j >= 0; j--) {
  //         const element = elements[j];
  //         if (element.type === "text" && element.subtype === null) {
  //           lastElementId = element.id;
  //           const rawHtml = element.text || "";
  //           const paragraphs = getParagraphsFromHtml(rawHtml);
  //           lastParagraphIndex = paragraphs.length - 1;
  //           break;
  //         }
  //       }
  //       if (lastElementId) break;
  //     }

  //     return {
  //       elementId: lastElementId,
  //       paragraphIndex: lastParagraphIndex >= 0 ? lastParagraphIndex : 0,
  //       isLast: true
  //     };
  //   }
  // }, [updateCards, isPremiumStory, isAdfree]);
  useEffect(() => {
    const onScroll = throttle(() => {
      if (window.scrollY > 500) setRenderTaboolaAd(true);
    }, 300);

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const shouldHaveCardAds = ["listicle", "photo", "news-briefs"].includes(template);

  useEffect(() => {
    const handleReadMoreLogic = () => {
      if (!storyContentRef.current) return;

      const firstAd = document.getElementById("FirstAdContainer");
      if (!firstAd) {
        setShouldShowReadMore(false);
        return;
      }

      const isMetered = ["dh-exclusive", "text", "syndicated"].includes(template);
      const count = getArticlesRemaining();
      const isSafeToDeploy = !isMetered || count === null || count === -1 || count >= 1;

      if (!isSafeToDeploy) {
        setShouldShowReadMore(false);
        setIsExpanded(true);
        return;
      }

      const contentHeight = storyContentRef.current.scrollHeight;
      const adOffsetTop = firstAd.offsetTop + (isMobile ? (shouldHaveCardAds ? 430 : 440) : 440);

      setShouldShowReadMore(contentHeight > adOffsetTop);

      if (!isExpanded) {
        setStoryContentMaxHeight(adOffsetTop);
      }
    };

    const raf = requestAnimationFrame(() => setTimeout(handleReadMoreLogic, 250));
    return () => cancelAnimationFrame(raf);
  }, [updateCards, isExpanded, isMobile, template, shouldHaveCardAds]);

  const isExclusiveStory = template === "dh-exclusive";

  // determine if this story should show the election brick wall and choose data
  const rawSlug = story?.slug || "";
  let showBrickWallStoryPage = false;
  let brickStateName = "";
  let brickElectionSlugData = null;
  let brickYear = "2024";

  if (rawSlug.includes("elections/bihar")) {
    showBrickWallStoryPage = true;
    brickStateName = "BIHAR";
    brickElectionSlugData = assemblyElection2025SlugData_Bihar;
    brickYear = "2025";
  } else if (rawSlug.includes("elections/maharashtra")) {
    showBrickWallStoryPage = true;
    brickStateName = "MAHARASHTRA";
    brickElectionSlugData = assemblyElection2024SlugData;
  } else if (rawSlug.includes("elections/jharkhand")) {
    showBrickWallStoryPage = true;
    brickStateName = "JHARKHAND";
    brickElectionSlugData = assemblyElection2024SlugData;
  } else if (rawSlug.includes("elections/delhi")) {
    showBrickWallStoryPage = true;
    brickStateName = "DELHI";
    brickElectionSlugData = assemblyElection2024SlugData_Delhi;
  } else if (rawSlug.includes("elections/haryana")) {
    showBrickWallStoryPage = true;
    brickStateName = "HARYANA";
    brickElectionSlugData = assemblyElection2024SlugData_JK_HR;
  } else if (rawSlug.includes("elections/jammu-and-kashmir")) {
    showBrickWallStoryPage = true;
    brickStateName = "J&K";
    brickElectionSlugData = assemblyElection2024SlugData_JK_HR;
  }

  return (
    <div styleName={`wrapper ${isImmersiveStory ? "remove-margin" : ""}`} ref={mainRef}>
      {template === "movie-review" && <MovieReviewView story={story} />}
      {template === "gadget-review" && <GadgetReviewView story={story} />}
      {template === "book-review" && <BookReviewView story={story} />}

      <div styleName="relative-wrapper" id="story-relative-wrapper">
        <div
          id={`story-content-${story.id}`}
          className="story-cards taboola-read-more-container"
          ref={storyContentRef}
          style={{
            maxHeight: !isExpanded && storyContentMaxHeight ? `${storyContentMaxHeight}px` : "none",
            overflow: isExpanded ? "visible" : "hidden",
            transition: "max-height 0.3s ease"
          }}
        >
          {updateCards.map((card, cardIndex) => (
            <React.Fragment key={card.id}>
              {shouldHaveCardAds && midAdsConfig[cardIndex] && (
                <div id={cardIndex === 2 && template !== "photo" ? "FirstAdContainer" : ""}>
                  <div styleName="ad-wrapper" className="hide-desktop">
                    <AdContainer
                      storyPageAds={midAdsConfig[cardIndex].mobile.storyPageAds}
                      AdClassName="standard-336x280"
                      id={midAdsConfig[cardIndex].mobile.id}
                      mobile={midAdsConfig[cardIndex].mobile.slot}
                    />
                    {cardIndex === 4 && isMobile && (
                      <div
                        id="taboola-mid-article-personalisation"
                        styleName="taboola-4u"
                        ref={(el) => {
                          if (!el) return;

                          window._taboola = window._taboola || [];
                          window._taboola.push({
                            mode: "organic-thumbnails-mid-personalisation-mob",
                            container: "taboola-mid-article-personalisation",
                            placement: "Mid Article Personalisation",
                            target_type: "mix",
                          });
                          window._taboola.push({ flush: true });
                        }}
                      />
                    )}
                  </div>
                  <div styleName="ad-wrapper" className="hide-mobile">
                    <AdContainer
                      AdClassName="standard-336x280"
                      id={midAdsConfig[cardIndex].desktop.id}
                      desktop={midAdsConfig[cardIndex].desktop.slot}
                    />
                    {cardIndex === 4 && !isMobile && (
                      <div
                        id="taboola-mid-article-personalisation"
                        ref={(el) => {
                          if (!el) return;

                          window._taboola = window._taboola || [];
                          window._taboola.push({
                            mode: "organic-thumbnails-mid-personalisation-desk",
                            container: "taboola-mid-article-personalisation",
                            placement: "Mid Article Personalisation",
                            target_type: "mix",
                          });
                          window._taboola.push({ flush: true });
                        }}
                      />
                    )}
                  </div>
                </div>
              )}
              <StoryCard
                card={card}
                story={story}
                cardIndex={cardIndex}
                index={index}
                isNewTextStory={isNewTextStory}
                adType={adType}
                isMobile={isMobile}
                isImmersiveStory={isImmersiveStory}
                tempHideAd={tempHideAd}
              />
            </React.Fragment>
          ))}
          {/* Premium paywall fallback render disabled. */}

          {!isImmersiveStory && (
            <>
              {/* {fourthTextStoryElementID(story) === null && (template === "text" || template === "syndicated") && (
                <SectionStories story={story} />
              )} */}
              {isFactCheck && <FactCheckView story={story} />}
              {!sponsoredText && isSponsoredStory && (
                <p styleName="story-note">Note: This is sponsored content curated by DH Brandspot.</p>
              )}
              {sponsoredText && (
                <p styleName="story-note">
                  Note: This article is part of syndicated content curated by our partners.
                </p>
              )}
              {isBrandspotNoAdStory && (
                <p styleName="story-note">
                  Note to readers: This article is part of Deccan Herald&apos;s paid consumer connect initiative. The
                  content is provided by the sponsor, and Deccan Herald is not responsible for errors, omissions, or
                  content accuracy.
                </p>
              )}
              {isBrandspotClientStory && (
                <p styleName="story-note">
                  Note: This is sponsored content. The views expressed here are solely those of the author.
                </p>
              )}
              {!tempHideAd && (
                <div styleName="ad-wrapper" className="hide-desktop">
                  <AdContainer
                    AdClassName="standard-336x280"
                    id={adType === "izooto" ? "div-gpt-ad-1711972114719-0" : "div-gpt-ad-1680157888251-0"}
                    mobile={adType === "izooto" ? "DH_MWeb_AT_Bottom_ym" : "DH_MWeb_AT_Bottom"}
                    isExternalAdPath={adType === "izooto"}
                  />
                </div>
              )}
              {showBrickWall && showBrickWallStoryPage && brickElectionSlugData && (
                <ElectionBrickWall
                  stateName={brickStateName}
                  showStateTabs={false}
                  electionSlugData={brickElectionSlugData}
                  electionData={assemblyElection2024ConstituencyData}
                  year={brickYear}
                  showSeperator={false}
                />
              )}
              {!isExclusiveStory && <PublishedAt story={story} />}
              <Tags story={story} />
              <PromotionalMessage story={story} />
              <SubscribeCard story={story} />
            </>
          )}
        </div>

        <div styleName={`read-more-overlay ${!isExpanded && shouldShowReadMore ? "visible" : ""}`}>
          <button styleName="read-more-button" onClick={() => { setIsExpanded(true); window.dispatchEvent(new CustomEvent("dh-content-expanded")); }}>
            Read More <DownArrow color="white" height="8px" width="14px" />
          </button>
        </div>
      </div>

      {!isImmersiveStory && renderTaboolaAd && (
        <TaboolaAd
          container={`taboola-below-article-${story.id}`}
          placement={`Below ${template === "video" ? "Video" : template === "photo" ? "Photo" : "Article"} Thumbnails`}
          mode="thumbnails-b"
        />
      )}
    </div>
  );
};

StoryElements.defaultProps = {
  isFactCheck: false,
  isMovieReview: false,
  isGadgetReview: false,
  isSponsoredStory: false,
  isBrandspotClientStory: false,
  isImmersiveStory: false,
  isNewTextStory: false,
  isBookReview: false
};

export default StoryElements;
